import '../social_content_context_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.TwitterContentContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = [
      Monitoring.Views.TwitterContentPreviousCommentsView,
      Monitoring.Views.TwitterContentFollowingCommentsView
    ]
    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()